// /* eslint-disable no-console */
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/HomeView.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () => import("@/views/ContactView.vue"),
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import("@/views/LegalView.vue"),
    props: () => ({ page: "privacy" }),
  },
  {
    path: "/licenses",
    name: "Licenses",
    component: () => import("@/views/LegalView.vue"),
    props: () => ({ page: "licenses" }),
  },
  {
    path: "/app/privacy",
    name: "App Privacy",
    component: () => import("@/views/LegalView.vue"),
    props: () => ({ page: "app/privacy" }),
  },
  {
    path: "/app/eula",
    name: "App EULA",
    component: () => import("@/views/LegalView.vue"),
    props: () => ({ page: "app/eula" }),
  },
  {
    path: "/app/terms",
    name: "App Terms",
    component: () => import("@/views/LegalView.vue"),
    props: () => ({ page: "app/terms" }),
  },
  {
    path: "/unsubscribe",
    name: "Unsubscribe",
    component: () => import("../views/UnsubscribeView.vue"),
  },
  {
    path: "/requestdelete",
    name: "Request Account Delete",
    component: () => import("../views/requestDeleteView.vue"),
  },
  {
    path: "/deleteaccount",
    name: "Delete Account",
    component: () => import("../views/deleteAccountView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/404View.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // scrollBehavior() {
  //   return { top: 0 };
  // },
});

// router.afterEach((to, from, failure) => {
//   console.log("to: ", to);
//   console.log("from: ", from);
//   if (isNavigationFailure(failure)) {
//     console.log("Failed Navigation: ", failure);
//   }
// });

export default router;
